(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      document.querySelectorAll('[data-cf-dd][open]').forEach(function(dd) {
        if (!dd.contains(e.target)) dd.open = false;
      });
    });
    // Only one dropdown open at a time
    document.querySelectorAll('[data-cf-dd]').forEach(function(dd) {
      dd.addEventListener('toggle', function() {
        if (dd.open) {
          document.querySelectorAll('[data-cf-dd]').forEach(function(other) {
            if (other !== dd) other.open = false;
          });
        }
      });
    });

    // Mobile drawer
    var toggle  = document.querySelector('[data-mobile-toggle]');
    var drawer  = document.getElementById('cf-mobile-drawer');
    var overlay = document.querySelector('[data-mobile-overlay]');
    var close   = document.querySelector('[data-mobile-close]');
    if (!toggle || !drawer) return;
    function openDrawer() { drawer.classList.add('cf-drawer--open'); drawer.setAttribute('aria-hidden','false'); toggle.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
    function closeDrawer() { drawer.classList.remove('cf-drawer--open'); drawer.setAttribute('aria-hidden','true'); toggle.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
    toggle.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (close)   close.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  (function () {
    var addBtn = document.getElementById('addr-add-btn');
    var addForm = document.getElementById('addr-add-form');

    if (addBtn && addForm) {
      addBtn.addEventListener('click', function () {
        addForm.style.display = addForm.style.display === 'none' ? 'block' : 'none';
        addBtn.style.display = 'none';
      });
    }

    document.querySelectorAll('[data-addr-cancel="add"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (addForm) addForm.style.display = 'none';
        if (addBtn) addBtn.style.display = '';
      });
    });

    document.querySelectorAll('[data-addr-edit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-addr-edit');
        var editForm = document.getElementById('addr-edit-' + id);
        if (editForm) {
          editForm.style.display = editForm.style.display === 'none' ? 'block' : 'none';
        }
      });
    });

    document.querySelectorAll('[data-addr-cancel]').forEach(function (btn) {
      var val = btn.getAttribute('data-addr-cancel');
      if (val === 'add') return;
      btn.addEventListener('click', function () {
        var editForm = document.getElementById('addr-edit-' + val);
        if (editForm) editForm.style.display = 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* ---- Helpers ---- */
    function fmtPrice(val) {
      var currency = document.getElementById('cart-drawer').dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(val);
      } catch (e) {
        return currency + ' ' + Number(val).toFixed(2);
      }
    }

    function fmtCents(cents) {
      return fmtPrice(cents / 100);
    }

    function spinner() {
      return '<div style="display:flex;justify-content:center;align-items:center;padding:2rem;"><div class="lokatan-spinner"></div></div>';
    }

    /* ---- Mobile Drawer ---- */
    var hamburgerBtn = document.getElementById('hamburger-btn');
    var drawerClose = document.getElementById('drawer-close');
    var mobileDrawer = document.getElementById('mobile-drawer');
    var mobileBackdrop = document.getElementById('mobile-backdrop');

    function openMobileDrawer() {
      mobileDrawer.removeAttribute('inert');
      mobileDrawer.classList.remove('-translate-x-full');
      mobileDrawer.classList.add('translate-x-0');
      mobileBackdrop.classList.remove('hidden');
      hamburgerBtn.classList.add('is-open');
      hamburgerBtn.setAttribute('aria-expanded', 'true');
      mobileDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileDrawer() {
      mobileDrawer.classList.add('-translate-x-full');
      mobileDrawer.classList.remove('translate-x-0');
      mobileBackdrop.classList.add('hidden');
      hamburgerBtn.classList.remove('is-open');
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      mobileDrawer.setAttribute('inert', '');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    hamburgerBtn.addEventListener('click', function () {
      mobileDrawer.classList.contains('translate-x-0') ? closeMobileDrawer() : openMobileDrawer();
    });
    drawerClose.addEventListener('click', closeMobileDrawer);
    mobileBackdrop.addEventListener('click', closeMobileDrawer);
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) closeMobileDrawer();
    });

    /* ---- Search Overlay ---- */
    var searchBtn = document.getElementById('search-btn');
    var searchOverlay = document.getElementById('search-overlay');
    var searchClose = document.getElementById('search-close');
    var searchInput = document.getElementById('search-input');
    var searchResults = document.getElementById('search-results');
    var searchTimer;

    function openSearch() {
      searchOverlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { searchInput.focus(); }, 50);
    }

    function closeSearch() {
      searchOverlay.classList.add('hidden');
      document.body.style.overflow = '';
      searchInput.value = '';
      searchResults.innerHTML = '';
    }

    function renderSearchResults(products, query) {
      if (!products || !products.length) {
        searchResults.innerHTML = '<p style="padding:2rem;text-align:center;font-size:0.875rem;color:#737373;">No results found.</p>';
        return;
      }
      var html = '<ul style="list-style:none;margin:0;padding:0;">';
      products.forEach(function (p) {
        var imgHtml;
        if (p.featured_image && p.featured_image.url) {
          var src = (p.featured_image.url.indexOf('//') === 0 ? 'https:' : '') + p.featured_image.url;
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=80';
          imgHtml = '<img src="' + src + '" alt="" style="width:3rem;height:3rem;object-fit:cover;border-radius:0.5rem;flex-shrink:0;">';
        } else {
          imgHtml = '<div style="width:3rem;height:3rem;background:#EDE6D8;border-radius:0.5rem;flex-shrink:0;"></div>';
        }
        var price = p.price ? fmtPrice(parseFloat(p.price)) : '';
        var comparePrice = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? fmtPrice(parseFloat(p.compare_at_price_max)) : '';
        html += '<li><a href="' + p.url + '" style="display:flex;align-items:center;gap:1rem;padding:0.875rem 1.25rem;text-decoration:none;color:inherit;" onmouseover="this.style.background=\'#F8F4EE\'" onmouseout="this.style.background=\'\'">';
        html += imgHtml;
        html += '<div style="flex:1;min-width:0;">';
        html += '<p style="margin:0;font-size:0.875rem;color:#1A1A1A;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + p.title + '</p>';
        if (price) {
          html += '<p style="margin:0.2rem 0 0;font-size:0.75rem;color:#737373;">';
          if (comparePrice) html += '<span style="text-decoration:line-through;color:#A8A096;margin-right:3px;">' + comparePrice + '</span> ';
          html += price + '</p>';
        }
        html += '</div></a></li>';
      });
      html += '</ul>';
      html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" style="display:flex;align-items:center;justify-content:center;gap:0.5rem;padding:1rem 1.25rem;font-size:0.75rem;text-transform:uppercase;letter-spacing:0.1em;color:#595959;border-top:1px solid #EDE6D8;text-decoration:none;" onmouseover="this.style.color=\'#1A1A1A\'" onmouseout="this.style.color=\'#595959\'">See all results <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg></a>';
      searchResults.innerHTML = html;
    }

    function fetchSearch(query) {
      if (!query || query.length < 2) { searchResults.innerHTML = ''; return; }
      searchResults.innerHTML = spinner();
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSearchResults(products, query);
        })
        .catch(function () {
          searchResults.innerHTML = '<p style="padding:2rem;text-align:center;font-size:0.875rem;color:#737373;">Something went wrong.</p>';
        });
    }

    searchBtn.addEventListener('click', openSearch);
    searchClose.addEventListener('click', closeSearch);
    searchOverlay.addEventListener('click', function (e) { if (e.target === searchOverlay) closeSearch(); });
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { fetchSearch(searchInput.value.trim()); }, 300);
    });

    /* ---- Cart Drawer ---- */
    var cartBtn = document.getElementById('cart-btn');
    var cartDrawerEl = document.getElementById('cart-drawer');
    var cartDrawerClose = document.getElementById('cart-drawer-close');
    var cartBackdrop = document.getElementById('cart-backdrop');
    var cartItemsEl = document.getElementById('cart-drawer-items');
    var cartFooterEl = document.getElementById('cart-drawer-footer');
    var cartSubtotalEl = document.getElementById('cart-subtotal');
    var cartCountEl = document.getElementById('cart-count');

    function updateBadge(count) {
      if (count > 0) {
        cartCountEl.textContent = count;
        cartCountEl.classList.remove('hidden');
      } else {
        cartCountEl.classList.add('hidden');
      }
    }

    function renderCart(cart) {
      updateBadge(cart.item_count);
      if (!cart.items || !cart.items.length) {
        cartItemsEl.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;padding:3rem 0;text-align:center;"><svg width="48" height="48" fill="none" stroke="#E0D5C2" viewBox="0 0 24 24" style="margin-bottom:1rem;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007z"/></svg><p style="font-size:0.875rem;color:#737373;margin:0;">Your cart is empty</p></div>';
        cartFooterEl.classList.add('hidden');
        return;
      }
      var html = '<ul style="list-style:none;margin:0;padding:0;">';
      cart.items.forEach(function (item) {
        var imgHtml;
        if (item.image) {
          var src = item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image;
          imgHtml = '<img src="' + src + '" alt="" style="width:4rem;height:4rem;object-fit:cover;border-radius:0.75rem;flex-shrink:0;">';
        } else {
          imgHtml = '<div style="width:4rem;height:4rem;background:#EDE6D8;border-radius:0.75rem;flex-shrink:0;"></div>';
        }
        html += '<li style="padding:1rem 0;display:flex;gap:1rem;border-bottom:1px solid #F8F4EE;">';
        html += imgHtml;
        html += '<div style="flex:1;min-width:0;">';
        html += '<p style="margin:0;font-size:0.875rem;color:#1A1A1A;line-height:1.4;">' + item.product_title + '</p>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<p style="margin:0.2rem 0 0;font-size:0.75rem;color:#8A7F76;">' + item.variant_title + '</p>';
        }
        html += '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:0.5rem;">';
        html += '<span style="font-size:0.75rem;color:#737373;">Qty ' + item.quantity + '</span>';
        html += '<div style="display:flex;align-items:center;gap:0.75rem;">';
        var hasSale = item.original_line_price > item.final_line_price;
        if (hasSale) html += '<span style="font-size:0.75rem;color:#A8A096;text-decoration:line-through;">' + fmtCents(item.original_line_price) + '</span>';
        html += '<span style="font-size:0.875rem;color:' + (hasSale ? '#C44A4A' : '#1A1A1A') + ';">' + fmtCents(item.line_price) + '</span>';
        html += '<button data-key="' + item.key + '" class="cart-rm" style="background:none;border:none;padding:0.2rem;cursor:pointer;color:#E0D5C2;line-height:0;" onmouseover="this.style.color=\'#1A1A1A\'" onmouseout="this.style.color=\'#E0D5C2\'">';
        html += '<svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12"/></svg>';
        html += '</button></div></div></div></li>';
      });
      html += '</ul>';
      cartItemsEl.innerHTML = html;
      cartSubtotalEl.textContent = fmtCents(cart.total_price);
      cartFooterEl.classList.remove('hidden');

      cartItemsEl.querySelectorAll('.cart-rm').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var remaining = cartItemsEl.querySelectorAll('.cart-rm').length - 1;
          cartItemsEl.innerHTML = remaining > 0 ? cartSkeletonHtml(remaining) : cartItemsEl.innerHTML;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
          }).then(function (r) { return r.json(); }).then(renderCart)
            .catch(function () { renderCart({ items: [], item_count: 0, total_price: 0 }); });
        });
      });
    }

    function loadCart() {
      var skeletonCount = Math.min(parseInt(cartCountEl.textContent) || 2, 5);
      cartItemsEl.innerHTML = cartSkeletonHtml(skeletonCount);
      fetch('/cart.json')
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {
          cartItemsEl.innerHTML = '<p style="text-align:center;font-size:0.875rem;color:#737373;padding:2rem;">Failed to load cart.</p>';
        });
    }

    function openCartDrawer() {
      cartDrawerEl.removeAttribute('inert');
      loadCart();
      cartDrawerEl.classList.remove('translate-x-full');
      cartDrawerEl.classList.add('translate-x-0');
      cartBackdrop.classList.remove('hidden');
      cartDrawerEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeCartDrawer() {
      cartDrawerEl.classList.add('translate-x-full');
      cartDrawerEl.classList.remove('translate-x-0');
      cartBackdrop.classList.add('hidden');
      cartDrawerEl.setAttribute('inert', '');
      cartDrawerEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    cartBtn.addEventListener('click', openCartDrawer);
    cartDrawerClose.addEventListener('click', closeCartDrawer);
    cartBackdrop.addEventListener('click', closeCartDrawer);

    /* ---- Account bottom sheet ---- */
    var mobileAccountBtn    = document.getElementById('mobile-account-btn');
    var accountSheetBackdrop = document.getElementById('account-sheet-backdrop');
    var accountSheet         = document.getElementById('account-sheet');

    function openAccountSheet() {
      closeMobileDrawer();
      accountSheetBackdrop.classList.remove('hidden');
      requestAnimationFrame(function () {
        accountSheet.classList.remove('translate-y-full');
        accountSheet.classList.add('translate-y-0');
      });
      document.body.style.overflow = 'hidden';
    }

    function closeAccountSheet() {
      accountSheet.classList.add('translate-y-full');
      accountSheet.classList.remove('translate-y-0');
      setTimeout(function () {
        accountSheetBackdrop.classList.add('hidden');
        document.body.style.overflow = '';
      }, 300);
    }

    mobileAccountBtn.addEventListener('click', openAccountSheet);
    accountSheetBackdrop.addEventListener('click', function (e) {
      if (e.target === accountSheetBackdrop) closeAccountSheet();
    });

    function cartSkeletonHtml(count) {
      var item =
        '<li style="padding:1rem 0;display:flex;gap:1rem;border-bottom:1px solid #F8F4EE;">' +
          '<div class="wl-skeleton" style="width:4rem;height:4rem;border-radius:0.75rem;flex-shrink:0;"></div>' +
          '<div style="flex:1;min-width:0;">' +
            '<div class="wl-skeleton" style="height:0.875rem;width:65%;border-radius:0.25rem;margin-bottom:0.35rem;"></div>' +
            '<div class="wl-skeleton" style="height:0.75rem;width:35%;border-radius:0.25rem;margin-bottom:0.6rem;"></div>' +
            '<div style="display:flex;justify-content:space-between;">' +
              '<div class="wl-skeleton" style="height:0.75rem;width:25%;border-radius:0.25rem;"></div>' +
              '<div class="wl-skeleton" style="height:0.75rem;width:20%;border-radius:0.25rem;"></div>' +
            '</div>' +
          '</div>' +
        '</li>';
      var html = '<ul style="list-style:none;margin:0;padding:0;">';
      for (var i = 0; i < count; i++) html += item;
      html += '</ul>';
      return html;
    }

    /* ---- Open cart drawer from ATC events ---- */
    document.addEventListener('lokatan:cart:open', function (e) {
      if (e.detail) renderCart(e.detail);
      openCartDrawer();
    });

    /* ---- Escape key ---- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!searchOverlay.classList.contains('hidden')) { closeSearch(); return; }
      if (!cartDrawerEl.classList.contains('translate-x-full')) { closeCartDrawer(); return; }
      if (!accountSheetBackdrop.classList.contains('hidden')) { closeAccountSheet(); return; }
      if (mobileDrawer.classList.contains('translate-x-0')) closeMobileDrawer();
    });

    /* ---- Fixed navbar: push body content down ---- */
    var headerOuter = document.getElementById('header-outer');

    /* ---- Floating effect on scroll (shadow only) ---- */
    function onScroll() {
      headerOuter.classList.toggle('is-floating', window.scrollY > 24);
    }

    function syncBodyPadding() {
      document.body.style.paddingTop = headerOuter.offsetHeight + 'px';
    }

    /* Read layout before any DOM writes to avoid forced reflow */
    syncBodyPadding();
    onScroll();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        requestAnimationFrame(function () {
          document.body.style.paddingTop = headerOuter.offsetHeight + 'px';
        });
      }).observe(headerOuter);
    } else {
      window.addEventListener('resize', function () {
        requestAnimationFrame(function () {
          document.body.style.paddingTop = headerOuter.offsetHeight + 'px';
        });
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---- Desktop dropdown menus ---- */
    var desktopParents = document.querySelectorAll('[data-nav-parent]');

    function openDropdown(parent) {
      var btn = parent.querySelector('.nav-link');
      var panel = parent.querySelector('.nav-dropdown');
      if (!btn || !panel) return;
      panel.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown(parent) {
      var btn = parent.querySelector('.nav-link');
      var panel = parent.querySelector('.nav-dropdown');
      if (!btn || !panel) return;
      panel.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    }

    function closeAllDropdowns(except) {
      desktopParents.forEach(function (p) {
        if (p !== except) closeDropdown(p);
      });
    }

    desktopParents.forEach(function (parent) {
      var btn = parent.querySelector('.nav-link');
      var panel = parent.querySelector('.nav-dropdown');
      if (!btn || !panel) return;

      /* hover */
      parent.addEventListener('mouseenter', function () { openDropdown(parent); });
      parent.addEventListener('mouseleave', function () { closeDropdown(parent); });

      /* keyboard: Enter/Space toggles */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAllDropdowns(parent);
          if (isOpen) { closeDropdown(parent); } else { openDropdown(parent); }
        }
        if (e.key === 'Escape') { closeDropdown(parent); btn.blur(); }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var first = panel.querySelector('a, button');
          if (first) first.focus();
        }
      });

      /* keyboard: arrow navigation inside panel */
      panel.addEventListener('keydown', function (e) {
        var items = Array.from(panel.querySelectorAll('a, button'));
        var idx = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (idx < items.length - 1) items[idx + 1].focus();
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (idx > 0) { items[idx - 1].focus(); } else { btn.focus(); }
        }
        if (e.key === 'Escape') { closeDropdown(parent); btn.focus(); }
        if (e.key === 'Tab') {
          /* close if tabbing past last item */
          if (!e.shiftKey && idx === items.length - 1) closeDropdown(parent);
          if (e.shiftKey && idx === 0) { e.preventDefault(); btn.focus(); closeDropdown(parent); }
        }
      });
    });

    /* close dropdowns on outside click */
    document.addEventListener('click', function (e) {
      desktopParents.forEach(function (parent) {
        if (!parent.contains(e.target)) closeDropdown(parent);
      });
    });

    /* ---- Mobile accordion menus ---- */
    document.querySelectorAll('[data-mob-parent]').forEach(function (parent) {
      var btn = parent.querySelector(':scope > button.mob-link');
      if (!btn) return;
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          panel.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-announcement-splide]');
    if (!el || typeof Splide === 'undefined') return;

    new Splide(el, {
      type: 'loop',
      arrows: false,
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      autoplay: true,
      pauseOnHover: true,
      interval: 4000,
      breakpoints: {
        1024: { perPage: 2 },
        640: { perPage: 1 }
      }
    }).mount();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-hero-mode="fixed"]');
    if (!hero) return;

    var inner = hero.querySelector('[data-hero-inner]');
    if (!inner) return;

    var DESKTOP_W = 1280;

    function applyScale() {
      inner.style.cssText = '';
      hero.style.height = '';

      if (window.innerWidth >= 1024) return;

      /* Read layout properties before writing any styles */
      var heroWidth = hero.offsetWidth;

      inner.style.width = DESKTOP_W + 'px';
      inner.style.maxWidth = 'none';
      inner.style.marginLeft = '0';
      inner.style.marginRight = '0';

      var scale = heroWidth / DESKTOP_W;
      inner.style.transformOrigin = 'top left';
      inner.style.transform = 'scale(' + scale + ')';

      /* Defer height write to rAF so offsetHeight read follows layout settle */
      requestAnimationFrame(function () {
        hero.style.height = (inner.offsetHeight * scale) + 'px';
      });
    }

    applyScale();
    window.addEventListener('resize', applyScale);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-new-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript.closest('.hnc-section');
    if (!section) return;

    var track    = section.querySelector('.hnc-track');
    var viewport = section.querySelector('.hnc-viewport');
    var slides   = section.querySelectorAll('.hnc-slide');
    var btnPrev  = section.querySelector('.hnc-prev');
    var btnNext  = section.querySelector('.hnc-next');
    var dots     = section.querySelectorAll('.hnc-dot');
    if (!track || slides.length === 0) return;

    var currentIndex = 0;
    var total = slides.length;

    function visibleCount() {
      return window.innerWidth >= 1024 ? 4 : 2;
    }

    function maxIndex() {
      return Math.max(0, total - visibleCount());
    }

    function getSlideWidth() {
      if (slides[0]) {
        return slides[0].getBoundingClientRect().width;
      }
      return 0;
    }

    function getGap() {
      return window.innerWidth >= 1024 ? 20 : 16;
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex()));
      var offset = currentIndex * (getSlideWidth() + getGap());
      track.style.transform = 'translateX(-' + offset + 'px)';
      updateUI();
    }

    function updateUI() {
      if (btnPrev) btnPrev.disabled = currentIndex === 0;
      if (btnNext) btnNext.disabled = currentIndex >= maxIndex();

      dots.forEach(function (dot, i) {
        dot.classList.toggle('hnc-dot--active', i === currentIndex);
      });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(currentIndex + 1); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Touch swipe */
    var touchStartX = 0;
    var touchDelta  = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchDelta  = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      touchDelta = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (touchDelta < -50) goTo(currentIndex + 1);
      if (touchDelta >  50) goTo(currentIndex - 1);
    });

    /* Mouse drag */
    var mouseDown = false;
    var mouseStartX = 0;
    var mouseDelta  = 0;

    track.addEventListener('mousedown', function (e) {
      mouseDown   = true;
      mouseDelta  = 0;
      mouseStartX = e.pageX;
      track.classList.add('hnc-dragging');
      e.preventDefault();
    });

    window.addEventListener('mouseup', function () {
      if (!mouseDown) return;
      mouseDown = false;
      track.classList.remove('hnc-dragging');
      if (mouseDelta < -60) goTo(currentIndex + 1);
      if (mouseDelta >  60) goTo(currentIndex - 1);
    });

    window.addEventListener('mousemove', function (e) {
      if (!mouseDown) return;
      mouseDelta = e.pageX - mouseStartX;
    });

    /* Prevent link click after drag */
    track.addEventListener('click', function (e) {
      if (Math.abs(mouseDelta) > 10) e.preventDefault();
    }, true);

    /* Recalculate on resize */
    window.addEventListener('resize', function () {
      goTo(currentIndex);
    });

    goTo(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var urls = {
      jnt:  function (n) { return 'https://www.jet.co.id/track/' + encodeURIComponent(n); },
      jne:  function (n) { return 'https://www.jne.co.id/id/tracking/trace/' + encodeURIComponent(n); },
      lion: function (n) { return 'https://lionparcel.com/tracking?stt=' + encodeURIComponent(n); }
    };

    var form    = document.getElementById('ot-form');
    var errorEl = document.getElementById('ot-error');

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.style.display = 'none';

      var number  = document.getElementById('ot-number').value.trim();
      var carrier = document.getElementById('ot-carrier').value;

      if (!number || !carrier || !urls[carrier]) {
        errorEl.style.display = 'block';
        return;
      }

      window.open(urls[carrier](number), '_blank', 'noopener,noreferrer');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var wrapper = document.querySelector('[data-search-section]');
    if (!wrapper) return;

    var searchInput = document.getElementById('search-page-input');
    var suggestions = document.getElementById('search-suggestions');
    var searchForm = document.querySelector('[data-search-form]');
    if (!searchInput || !suggestions) return;

    var searchTimer;
    var currency = wrapper.dataset.currency || 'USD';

    function fmtPrice(val) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(val);
      } catch (e) {
        return currency + ' ' + Number(val).toFixed(2);
      }
    }

    function renderSuggestions(products, query) {
      if (!products || !products.length) {
        suggestions.classList.add('hidden');
        suggestions.innerHTML = '';
        return;
      }

      var html = '<ul style="list-style:none;margin:0;padding:0;">';
      products.forEach(function (p) {
        var imgHtml;
        if (p.featured_image && p.featured_image.url) {
          var src = (p.featured_image.url.indexOf('//') === 0 ? 'https:' : '') + p.featured_image.url;
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=80';
          imgHtml = '<img src="' + src + '" alt="" style="width:2.5rem;height:2.5rem;object-fit:cover;border-radius:0.5rem;flex-shrink:0;">';
        } else {
          imgHtml = '<div style="width:2.5rem;height:2.5rem;background:#EDE6D8;border-radius:0.5rem;flex-shrink:0;"></div>';
        }
        var price = p.price ? fmtPrice(parseFloat(p.price)) : '';
        var comparePrice = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? fmtPrice(parseFloat(p.compare_at_price_max)) : '';
        html += '<li><a href="' + p.url + '" class="sr-item" style="display:flex;align-items:center;gap:0.75rem;padding:0.75rem 1.25rem;text-decoration:none;color:inherit;">';
        html += imgHtml;
        html += '<div style="flex:1;min-width:0;">';
        html += '<p style="margin:0;font-size:0.8125rem;color:#1A1A1A;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + p.title + '</p>';
        if (price) {
          html += '<p style="margin:0.15rem 0 0;font-size:0.75rem;display:flex;align-items:baseline;gap:4px;">';
          if (comparePrice) html += '<s style="color:#595959;font-weight:400;">' + comparePrice + '</s>';
          html += '<span style="color:#737373;font-weight:' + (comparePrice ? '700' : '400') + ';">' + price + '</span></p>';
        }
        html += '</div></a></li>';
      });
      html += '</ul>';
      html += '<a href="' + searchForm.action + '?q=' + encodeURIComponent(query) + '&type=product" style="display:flex;align-items:center;justify-content:center;gap:0.5rem;padding:0.875rem 1.25rem;font-size:0.65rem;text-transform:uppercase;letter-spacing:0.1em;color:#595959;border-top:1px solid #EDE6D8;text-decoration:none;" onmouseover="this.style.color=\'#1A1A1A\'" onmouseout="this.style.color=\'#595959\'">See all results <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg></a>';
      suggestions.innerHTML = html;
      suggestions.classList.remove('hidden');
    }

    function fetchSuggestions(query) {
      if (!query || query.length < 2) {
        suggestions.classList.add('hidden');
        suggestions.innerHTML = '';
        return;
      }

      suggestions.innerHTML = '<div style="display:flex;justify-content:center;padding:1.5rem;"><div class="lokatan-spinner"></div></div>';
      suggestions.classList.remove('hidden');

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSuggestions(products, query);
        })
        .catch(function () {
          suggestions.innerHTML = '<p style="padding:1rem;text-align:center;font-size:0.8125rem;color:#737373;">Something went wrong.</p>';
        });
    }

    /* ---- Input event: lazy load suggestions ---- */
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { fetchSuggestions(searchInput.value.trim()); }, 300);
    });

    /* ---- Focus/blur: show/hide suggestions ---- */
    searchInput.addEventListener('focus', function () {
      var val = searchInput.value.trim();
      if (val.length >= 2 && !suggestions.classList.contains('hidden')) {
        suggestions.classList.remove('hidden');
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        suggestions.classList.add('hidden');
      }
    });

    /* ---- Hide suggestions on form submit ---- */
    searchForm.addEventListener('submit', function () {
      suggestions.classList.add('hidden');
    });
  })();

  // Desktop: close dropdowns on outside click, only one open at a time
  (function() {
    document.addEventListener('click', function(e) {
      document.querySelectorAll('[data-cf-dd][open]').forEach(function(dd) {
        if (!dd.contains(e.target)) dd.open = false;
      });
    });
    document.querySelectorAll('[data-cf-dd]').forEach(function(dd) {
      dd.addEventListener('toggle', function() {
        if (dd.open) {
          document.querySelectorAll('[data-cf-dd]').forEach(function(other) {
            if (other !== dd) other.open = false;
          });
        }
      });
    });
  })();

  // Mobile filter drawer
  (function() {
    var toggle  = document.querySelector('[data-mobile-toggle]');
    var drawer  = document.getElementById('sr-mobile-drawer');
    var overlay = document.querySelector('[data-mobile-overlay]');
    var closeBtn = document.querySelector('[data-mobile-close]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('cf-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('cf-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (overlay)  overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
